import { useUserSwitchAnimationInit } from "@/hooks/use-user-switch-animation-init";
import { createContext } from "react";

const UserSwitchContext = createContext<ReturnType<typeof useUserSwitchAnimationInit> | null>(null);

export default UserSwitchContext;
